import Layers from "slotworks/graphics/layers/layers";
import RevolverExitFreespins from "slotworks/integration/revolver/states/revolver-exit-freespins";
import deviceInfo from "slotworks/utils/device-info";
import HarleyComponents from "components/components";
import Contract from "slotworks/utils/contract";
import { parallel, sequence } from "slotworks/utils/race-utils";
import betModel from "slotworks/model/bets/bet-model";
import gameState from "slotworks/model/game-state";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Components from "slotworks/components/components";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import ShowPromoFSafterFreespins from "slotworks/commands/promo-free-spins/show-pfs-after-freespins";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import BetMenuMediator from "slotworks/mediators/bet-menu-mediator";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { ShowBaseLayersFull } from "commands/base-layers-commands";
import translations from "slotworks/i18n/translations";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";

export default class HarleyExitFreespins extends RevolverExitFreespins {

    public static DELAY_BEFORE_EXIT = 1000;
    protected summaryScenes: string[] = ["freespinssummary", "freespins"];
    protected promptContents: Map<string, string>;

    public onEnter() {
        setTimeout(() => {
            if (!deviceInfo.isDesktop) {
                Layers.BetBar.hide();
                Layers.SmartButton.hide();
            }
            Layers.Footer.defaultScene().execute();
            HarleyComponents.messages.setDefault();
            HarleyComponents.quickHit.restoreDefaultCounts();
            HarleyComponents.quickHit.stop();
            // //    SmartButton.setFlag(SmartButtonFlag.PROMPT, true);
            this.startFreespinsBigWin().then(bigWin => {
                if (bigWin) {
                    // Layers.PromoBetBar.show();
                    // Layers.SmartButton.show();
                    this.afterPrompt().then(() => this.complete());
                } else {
                    this.showPromptWin().then(() => this.complete());
                }
            });
        }, HarleyExitFreespins.DELAY_BEFORE_EXIT);
    }

    protected showPromptWin(): Contract<void> {
        return new Contract<void>(resolve => {
            this.prompt = null;
            this.promptContents = new Map<string, string>();
            sequence([
                // hide matrix
                () => this.setupPrompt(),
                () => this.showPrompt(),
                () => this.afterPrompt()
            ]).then(() => {
                resolve(null);
            });
        });
    }

    // mediator part, not really needed to be mediator
    protected startFreespinsBigWin(): Contract<boolean> {
        const freeSpinsWin = this.getCreditsWon();
        const stake = betModel.getTotalBet();
        return HarleyComponents.freespinsBigWin.showWin(freeSpinsWin, stake);
    }

    public complete() {
        gameState.getCurrentGame().inFreespinsGame = false;
        regulation.updateNetPosition(gameState.getNetPosition());
        this.setWinnings();
        super.complete();
    }

    private getCreditsWon() {
        const freeSpinsWin = gameState.getCurrentGame().getRunningFreespinsWinTotal();
        if (freeSpinsWin)
            return freeSpinsWin;
        return gameState.getCurrentGame().totalCreditsWon;
    }

    protected setupPrompt() {
        return Contract.wrap(() => {

            if (Layers.CelebrationBackground.hasScene("glowstack")) {
                Layers.CelebrationBackground.setScene("glowstack").execute();
            }

            smartButton.setFlag(SmartButtonFlag.PROMPT, true);

            const freeSpinsWin = this.getCreditsWon();
            let message;
            let summaryScene;
            let time = 3500;
            let noWin: boolean;
            summaryScene = "freespinssummary";


            this.prompt = new PromptContent([summaryScene, ...this.summaryScenes], time);
            if (!noWin) {
                this.prompt.addContinueButton("continue");
                
                let lastRecord: FreespinRecord;
                const records = gameState.getCurrentGame().records;
                for(let i = records.length - 1; i >= 0; i--) {
                    if(records[i] instanceof FreespinRecord) {
                        lastRecord = records[i] as FreespinRecord;
                        break;
                    }
                } 
                if(!lastRecord) {
                    lastRecord = records[0] as FreespinRecord;
                }
                const resultsText = translations.get("freespins_results_line_1", {SPINS: lastRecord.totalFreespins});
                this.promptContents.set("freespins_results_line_1", resultsText);
            }

            this.prompt.addText(this.promptContents);

            this.prompt.countupText("value", freeSpinsWin, 3000);
        });
    }

    protected showPrompt(): Contract<void> {
        return Components.prompt.showPrompt(this.prompt);

    }

    protected afterPrompt() {
        return parallel([
            () => Contract.wrap(() => {
                smartButton.setFlag(SmartButtonFlag.PROMPT, false);
            }),
            () => this.hideFreespinsComponents(),
            () => this.resetToTriggeringSpin()
        ]);
    }

    protected hideFreespinsComponents(): Contract<void> {
        return parallel([
            () => Layers.Background.defaultScene(),
            () => Layers.Header.defaultScene(),
            () => Contract.wrap(() => Components.banner.setMode("default")),
            () => Contract.wrap(() => Components.footer.showDefaultText())
        ]);
    }

    protected setWinnings(): void {
        const totalWin = gameState.getCurrentGame().totalCreditsWon;
        Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);
    }

    protected showTriggeringSpinWin(totalWin: number, triggeringWin: number) {
        const isBigWin = Components.bigWin.isBigWin(totalWin, betModel.getTotalBet());

        if (!isBigWin) {
            Components.betBar.winnings.setWinnings(triggeringWin);
        }
    }

    protected resetToTriggeringSpin() {
        return Contract.wrap(() => {
            const freeSpinsWin = gameState.getCurrentGame().getRunningFreespinsWinTotal();

            smartButton.setFlag(SmartButtonFlag.FREE_SPINS, false);
            smartButton.setFlag(SmartButtonFlag.PROMPT, false);

            if (campaignsModel.isFreespinsActive()) {
                ShowPromoFSafterFreespins();
            } else {
                Layers.BetBar.show();
            }
            Layers.SmartButton.show();
            Components.betBar.setType(BetBarType.DEFAULT);
            Components.betBar.setEnabled(false);

            const betMenuMediator = new BetMenuMediator();
            betMenuMediator.start().execute();
            betMenuMediator.end();

            const record = gameState.getCurrentGame().resetRecordIndex() as SpinRecord;

            const triggeringWin: number = record.creditsWon;

            record.creditsWon += freeSpinsWin;
            record.beenPaid = true;

            this.showTriggeringSpinWin(record.creditsWon, triggeringWin);

            // Can't reset reels during recovered game
            if (!gameState.getCurrentGame().isRecovered) {
                Components.matrix.jumpToGrid(record.grid);
            }
        });
    }

    public onExit() {
        HarleyComponents.bonusBuyButton.show();
        Layers.CelebrationBackground.setScene("default").execute();
        ShowBaseLayersFull();
        // HarleyComponents.background.start();
        super.onExit();
    }

}